<script>
  /* global $p */
  import { mapActions } from 'vuex'
  import config from 'config/liftigniter'
  import get from 'lodash/get'
  import isFunction from 'lodash/isFunction'
  import map from 'lodash/map'
  import EventBus from 'components/helpers/event-bus'

  export default {
    props: {
      jsKey: {
        type: String,
        required: true,
      },
    },
    mounted() {
      if (this.jsKey && !get(window, '$p', false)) {
        /* eslint-disable */
        // check is jsKey exist, is client-side and not yet init
        (function (w, d, s, p, v, e, r) {
          w.$ps = (w.performance && w.performance.now &&
            typeof (w.performance.now) === 'function')
            ? w.performance.now()
            : undefined
          w.$igniter_var = v
          w[v] = w[v] || function () {
            (w[v].q = w[v].q || []).push(
              arguments)
          }
          w[v].l = 1 * new Date()
          e = d.createElement(s), r = d.getElementsByTagName(s)[0]
          e.async = 1
          e.src = `${p}?ts=${+new Date() / 3600000 | 0}`
          r.parentNode.insertBefore(e, r)
        }(window, document, 'script', `//cdn.petametrics.com/${this.jsKey}.js`, '$p'))
        /* eslint-enable */

        // custom liftigniter init boolean in vue store.
        this.setIsLiftigniterInit(true)

        const customConfig = {
          inventory: {
            collect: false,
            version: undefined,
          },
          sdk: {
            requestFields: get(config, 'LIFTIGNITER_INVENTORY_FIELD', []),
            multiFetch: true,
          },
        }
        $p('init', this.jsKey, {config: customConfig})
        EventBus.$on('liftigniter-ResetPageview', () => {
          this.resetPageview()
        })
        EventBus.$on('liftigniter-SendPageView', () => {
          this.sendPageView()
        })
        EventBus.$on('liftigniter-FetchInventory', (max, opts, resolve) => {
          if (isFunction(resolve)) {
            this.isReady().then(() => { this.fetchInventory(max, opts, resolve) }).catch(() => {
              resolve([])
            })
          }
        })
      }
    },
    methods: {
      ...mapActions([
        'setIsLiftigniterInit',
      ]),
      isReady() {
        return new Promise((resolve, reject) => {
          if (typeof window !== 'undefined' && isFunction($p)) resolve()
          reject(new Error('Liftigniter does not inited yet.'))
        })
      },
      resetPageview() {
        this.isReady().then(() => {
          $p('resetPageview')
        }).catch((e) => {
          console.log(e)
        })
      },
      sendPageView() {
        this.isReady().then(() => {
          $p('send', 'pageview')
        }).catch((e) => {
          console.log(e)
        })
      },
      fetchInventory: (max = 10, opts = {}, resolve) => {
        $p('register', {
          max,
          opts,
          widget: '',
          callback(resp) {
            resolve(map(get(resp, 'items', []), 'id'))
          },
        })
        $p('fetch')
      },
    },
    render(h) {
      return h
    },
  }

</script>



// WEBPACK FOOTER //
// liftigniterHelper.vue?4aa816a6